define(function(require) {
    return {
        START_MAP_TARGET_DECORATION_STYLE : {
            ID : "s_FIND_ROUTES_START_DECORATION",
            SYMBOLIZERS : [
                {
                    SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                    COLOR : "rgba(255,255,255,1)",
                    FONT_NAME : "CartoVistaCartographic",
                    FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                    SYMBOL_CHAR : ")",
                    HAS_DROP_SHADOW : true,
                    DROP_SHADOW_COLOR : "rgba(0,0,0,0.7)",
                    SIZE : 29,
                    OFFSET_X : -4,
                    OFFSET_Y : -13
                }, {
                    SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                    COLOR : "rgba(233,131,22,1)",
                    FONT_NAME : "CartoVistaCartographic",
                    FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                    SYMBOL_CHAR : ")",
                    SIZE : 25,
                    OFFSET_X : -4,
                    OFFSET_Y : -14
                }
            ]
        },
        END_MAP_TARGET_DECORATION_STYLE : {
            ID : "s_FIND_ROUTES_END_DECORATION",
            SYMBOLIZERS : [
                {
                    SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                    COLOR : "rgba(255,255,255,1)",
                    FONT_NAME : "CartoVistaCartographic",
                    FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                    SYMBOL_CHAR : ")",
                    HAS_DROP_SHADOW : true,
                    DROP_SHADOW_COLOR : "rgba(0,0,0,0.7)",
                    SIZE : 29,
                    OFFSET_X : -4,
                    OFFSET_Y : -13
                }, {
                    SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                    COLOR : "rgba(50,205,164,1)",
                    FONT_NAME : "CartoVistaCartographic",
                    FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                    SYMBOL_CHAR : ")",
                    SIZE : 25,
                    OFFSET_X : -4,
                    OFFSET_Y : -14
                }
            ]
        }
    };
});
